import React from 'react';
import { Link } from 'react-router-dom';

const NewsCard = ({ article }) => {
  if (!article) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const excerpt = article.description || article.content?.substring(0, 150) || '';
  const displayExcerpt = excerpt.length > 150 ? excerpt.substring(0, 150) + '...' : excerpt;

  return (
    <article className="card h-full flex flex-col">
      {/* Image */}
      {article.image_url && (
        <div className="relative h-48 md:h-56 overflow-hidden">
          <img
            src={article.image_url}
            alt={article.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      )}

      {/* Content */}
      <div className="p-6 flex flex-col flex-grow">
        {/* Category */}
        {article.category && article.category.length > 0 && (
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wide mb-2">
            {article.category[0]}
          </span>
        )}

        {/* Title */}
        <h2 className="text-xl font-bold text-neutral-900 mb-3 line-clamp-2">
          {article.title}
        </h2>

        {/* Excerpt */}
        <p className="text-neutral-600 mb-4 flex-grow line-clamp-3">
          {displayExcerpt}
        </p>

        {/* Meta Info */}
        <div className="flex items-center justify-between text-sm text-neutral-500 mb-4">
          <span>{formatDate(article.pubDate)}</span>
          {article.creator && article.creator.length > 0 && (
            <span>{article.creator[0]}</span>
          )}
        </div>

        {/* Read More Link */}
        <Link
          to={`/article/${article.article_id}`}
          className="text-primary-600 hover:text-primary-700 font-semibold text-sm inline-flex items-center group"
        >
          Read More
          <svg
            className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </article>
  );
};

export default NewsCard;
